import { client } from "../../client";
import {
  StudentOrTeacherAssignmentFragment,
  StudentOrTeacherAssignmentToggleDocument,
  StudentOrTeacherAssignmentToggleMutation,
  StudentOrTeacherAssignmentToggleMutationVariables,
} from "../types";

// [Student or Teacher] Toggles the completion of assignment
// eslint-disable-next-line import/prefer-default-export
export async function studentOrTeacherToggleAssignment(
  variables: StudentOrTeacherAssignmentToggleMutationVariables
): Promise<Readonly<StudentOrTeacherAssignmentFragment>> {
  try {
    const result = await client.mutate<
      StudentOrTeacherAssignmentToggleMutation,
      StudentOrTeacherAssignmentToggleMutationVariables
    >({
      mutation: StudentOrTeacherAssignmentToggleDocument,
      variables,
    });
    return result.data.insert_assignment_submits_one.assignment;
  } catch (error) {
    throw Error(error);
  }
}
